import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { mergeMap, catchError, map } from 'rxjs';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import * as filterActions from '../actions/filter.actions';
import { DashboardWidgetFilterService } from '../../../dashboard-widget/services/dashboard-widget-filter-service';
import { RuleSet } from 'ngx-angular-query-builder';
import {ListTypeUserDataFilterService} from "@common/filter/services/list-type-user-data-filter.service";

@Injectable()
export class FilterEffects {

  constructor(
    private readonly actions$: Actions,
    private readonly dashboardWidgetFilterService: DashboardWidgetFilterService,
    private readonly listTypeUserDataFilterService: ListTypeUserDataFilterService) {
  }


  loadWidgetFilter$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<filterActions.LoadWidgetFilter>(filterActions.LOAD_WIDGET_FILTER),
    mergeMap(action =>
      this.dashboardWidgetFilterService.loadFilter(action.payload.widgetId.toString()).pipe(
        map((filter: RuleSet) => {
          return new filterActions.LoadWidgetFilterComplete(
            new filterActions.WidgetFilterActionPayload(action.payload.widgetId, filter));
        }),
        catchError(err => of(new filterActions.LoadWidgetFilterError(new filterActions.WidgetFilterActionPayload(action.payload.widgetId), err)))
      ))));


  updateWidgetFilter$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<filterActions.UpdateWidgetFilter>(filterActions.UPDATE_WIDGET_FILTER),
    mergeMap(action => {
      return this.dashboardWidgetFilterService.saveFilter(action.payload.widgetId.toString(), action.payload.filter).pipe(
        map(() => new filterActions.UpdateWidgetFilterComplete(new filterActions.WidgetFilterActionPayload(action.payload.widgetId, action.payload.filter))),
        catchError(err => of(new filterActions.UpdateWidgetFilterError(new filterActions.WidgetFilterActionPayload(action.payload.widgetId), err)))
      );
    })));


  loadListTypeFilter$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<filterActions.LoadListTypeFilter>(filterActions.LOAD_LIST_TYPE_FILTER),
    mergeMap(action =>
      this.listTypeUserDataFilterService.loadFilter(action.payload.listType).pipe(
        map((filter: RuleSet) => {
          return new filterActions.LoadListTypeFilterComplete(
            new filterActions.ListTypeFilterActionPayload(action.payload.listType, filter));
        }),
        catchError(err => of(new filterActions.LoadListTypeFilterError(new filterActions.ListTypeFilterActionPayload(action.payload.listType), err)))
      ))));


  saveListTypeFilter$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<filterActions.SaveListTypeFilter>(filterActions.SAVE_LIST_TYPE_FILTER),
    mergeMap(action => {
      return this.listTypeUserDataFilterService.saveFilter(action.payload.listType, action.payload.filter).pipe(
        map(() => new filterActions.SaveListTypeFilterComplete(new filterActions.ListTypeFilterActionPayload(action.payload.listType, action.payload.filter))),
        catchError(err => of(new filterActions.SaveListTypeFilterError(new filterActions.ListTypeFilterActionPayload(action.payload.listType), err)))
      );
    })));

}
